import {IReviewEntity } from './reviewEntity.types';
import { AppConstants as _app } from '@/shared/app.constants';

export class ReviewEntity  implements IReviewEntity {
    public externalReviewId: number
    public reviewerId: number
    public applicationId: number
    public workflowStatusId: number

    constructor(data: any){
        this.externalReviewId = data.externalReviewId;
        this.applicationId = data.applicationId;
        this.reviewerId = data.reviewerId;
        this.workflowStatusId = data.workflowStatusId;
    }
    
}